import React, { useEffect } from "react";
import { loadUser } from "./data/reducers/auth";
import store from "./data/store";
import setAuthToken from "./helpers/setAuthToken";
import Routes from "./routes";

function App() {
  useEffect(() => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
      store.dispatch(loadUser());
    }
  }, []);

  return <Routes />;
}

export default App;
